import React from 'react';
import { oneOf, string } from 'prop-types';
import { BadgeContainer } from './style';
import { TYPE_PROPS, ORDER_VARIANT_PROPS } from './constant';

const normalizeOrderVariant = (orderVariant) => {
  return orderVariant?.toUpperCase();
};

/**
 * Badge component to display a badge with different types and variants.
 * Reference: https://www.figma.com/file/vjLoYdxktDSPkKEb0SsTB7/BETA-%5BComponents%5D-Web-UI-Kit?type=design&node-id=3317-1691&t=TJoMNUWwpQudoJwe-0
 * @typedef {{
 *   type: 'Multiplier' | 'Notation' | 'Prime' | 'Bonus' | 'Order',
 *   orderVariant?: 'Sell' | 'Buy'
 * }} BadgeProps
 *
 * @param {BadgeProps} props - The props object containing the badge properties.
 * @returns {JSX.Element|null} - The rendered Badge component.
 *
 * Usage:
 * <Badge type={badgeType} orderVariant={badgeOrderVariant} />
 *
 * Props:
 * - type: The type of the badge. Possible values: 'Multiplier', 'Notation', 'Prime', 'Bonus', 'Order'.
 * - orderVariant: The variant for 'Order' type. Possible values: 'Sell', 'Buy'.
 */
const Badge = ({ textBuy, textSell, type, orderVariant }) => {
  let textInfo = '';

  switch (type) {
    case 'Multiplier':
      return null; // todo - only handle for table cell
    case 'Notation':
      return null; // todo - only handle for table cell
    case 'Prime':
      return null; // todo - only handle for table cell
    case 'Bonus':
      textInfo = 'Hadiah';
      break;
    case 'Order':
      textInfo =
        (normalizeOrderVariant(orderVariant) === 'BUY' && textBuy) ||
        (normalizeOrderVariant(orderVariant) === 'SELL' && textSell);
      break;
    default:
      break;
  }

  return (
    <BadgeContainer
      type={type}
      orderVariant={normalizeOrderVariant(orderVariant)}
      textBuy={textBuy}
      textSell={textSell}
    >
      {textInfo}
    </BadgeContainer>
  );
};

Badge.propTypes = {
  type: oneOf(TYPE_PROPS).isRequired,
  orderVariant: oneOf([...ORDER_VARIANT_PROPS.BUY, ...ORDER_VARIANT_PROPS.SELL]),
  textBuy: string,
  textSell: string,
};

Badge.defaultProps = {
  orderVariant: 'Buy',
  textBuy: 'Beli',
  textSell: 'Jual',
};

export default Badge;
